<template>
  <div class="col-12">
    <SearchCard
      :title="$lang.change_person_identity_list"
      :url="url"
      :filterCatch="true"
      cardClass="border-0 p-3"
      ref="searchCard"
      @updatePermissions="updatePermissions"
    >
      <template slot="html" slot-scope="{ item }">
        <b-col
          cols="12"
          md="12"
          class="mb-3 pb-3 px-0 border border-top-0 border-right-0 border-left-0 border-light"
        >
          <b-row align-h="center">
            <b-col cols="" md="" class="fs_1rem font-weight-bold pb-md-0 pb-3">
              <b v-text="$lang.information_for" />&nbsp;
              <ProfileBoxPopupWrapper
                :data="item"
                deskTopPopupClass="top-230"
                nameClass="color-complementary"
              />
            </b-col>
            <b-col cols="auto" md="auto">
              <span
                :class="`w-auto d-flex align-items-center justify-content-between badge_style badge_style--${getStatusColor(
                  item
                )}`"
                v-b-tooltip.hover
                :title="
                  pathOr('', ['person_main_data_status', 'caption'], item)
                "
              >
                {{ pathOr("", ["person_main_data_status", "caption"], item) }}
              </span>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="12" class="px-0">
          <b-row>
            <b-col cols="12" class="py-2">
              <b v-text="$lang.term" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['term_caption'], item)"
              />
            </b-col>
            <b-col cols="12" md="4" class="py-2">
              <b v-text="$lang.request_at" />:
              <span
                class="text-muted"
                v-html="
                  createDateFormat(pathOr('', ['request_at', 'jalali'], item))
                "
              />
            </b-col>
            <b-col
              v-if="
                pathOr(null, ['sender_user', 'full_name'], item) !==
                pathOr('', ['confirm_user', 'full_name'], item)
              "
              cols="12"
              md="4"
              class="py-2"
            >
              <b v-text="$lang.sender_user" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['sender_user', 'full_name'], item)"
              />
            </b-col>
            <b-col cols="12" md="4" class="py-2">
              <b v-text="$lang.confirm_user" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['confirm_user', 'full_name'], item)"
              />
            </b-col>
            <b-col
              v-if="pathOr(null, ['activity_at', 'jalali'], item)"
              cols="12"
              md="4"
              class="py-2"
            >
              <b v-text="$lang.activity_at" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['activity_at', 'jalali'], item)"
              />
            </b-col>
            <b-col
              v-if="pathOr(null, ['reject_reason'], item)"
              cols="12"
              md="12"
              class="py-2"
            >
              <b v-text="$lang.reject_reason" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['reject_reason'], item)"
              />
            </b-col>
            <b-col cols="12" md="12" class="py-2">
              <b v-text="$lang.change_description" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['change_description'], item)"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col
          v-if="
            isAdmin(permissions) &&
            pathOr(null, ['person_main_data_status', 'id'], item) === 1
          "
          cols="12"
          md="12"
          class="text-right pt-3 mt-3 px-0 border border-bottom-0 border-right-0 border-left-0 border-light"
        >
          <b-row align-v="center">
            <b-col md="auto" />
            <b-col
              cols="12"
              md=""
              class="text-md-right text-center text-muted pb-md-0"
            >
              <ExpandButton
                variant="success"
                :expandable="true"
                :expanded="false"
                :disabled="false"
                :circle="true"
                :loading="false"
                icon="account-convert-outline"
                :text="'بررسی'"
                :tooltip="'بررسی'"
                cls="mx-1"
                :condition="
                  isAdmin(permissions) &&
                  pathOr(null, ['person_main_data_status', 'id'], item) === 1
                "
                @click="editPersonIdentity(item)"
              />
            </b-col>
          </b-row>
        </b-col>
      </template>
    </SearchCard>
    <b-modal
      no-close-on-backdrop
      v-model="personIdentityModal"
      size="md"
      hide-footer
      hide-header
    >
      <EditPersonIdentity
        :id="id"
        :parentPermissions="permissions"
        @close="personIdentityModal = false"
        @getData="getData"
      />
    </b-modal>
  </div>
</template>

<script>
import { ProfileBoxPopupWrapper } from "@/components/re-design";
import SearchCard from "@/components/base/searchCard";
import EditPersonIdentity from "./components/EditPersonIdentity";
import ExpandButton from "@/components/global/ExpandButton";
import { pathOr, includes } from "ramda";
import { generateApiUrl, isAdmin, createDateFormat } from "@/shared/utils";

export default {
  name: "search-person-identity",
  components: {
    SearchCard,
    EditPersonIdentity,
    ExpandButton,
    ProfileBoxPopupWrapper,
  },
  data() {
    return {
      id: null,
      personIdentityModal: false,
      buttons: [
        {
          id: "54",
          name: "acceptPersonIdentity",
          iconFont: "fa fa-check-circle fa-lg text-success",
          text: this.$lang.accept_change_person_identity,
          click: this.editPersonIdentity,
        },
      ],
      permissions: [],
      hiddenFields: ["created_by", "created_at.jalali"],
    };
  },
  computed: {
    url() {
      return generateApiUrl(["profile", "person_identity_change"]);
    },
  },
  methods: {
    pathOr,
    includes,
    generateApiUrl,
    isAdmin,
    createDateFormat,
    getData() {
      this.$refs.searchCard.getItems();
    },
    updatePermissions(permissions) {
      this.permissions = [...permissions];
    },
    editPersonIdentity(item) {
      const statusId = pathOr(null, ["person_main_data_status", "id"], item);
      /* guidance: for continue its status must be 1 */
      if (statusId !== 1) return;
      this.id = pathOr(null, ["id"], item);
      this.personIdentityModal = true;
    },
    getStatusColor(item) {
      const colors = {
        1: "warning",
        2: "success",
        3: "danger",
      };
      const key = pathOr(null, ["person_main_data_status", "id"], item);
      return pathOr("", [key], colors);
    },
  },
};
</script>
